export default {
  state: {
    APPLICATION: undefined,
  },
  mutations: {
    // store Application data
    storeAPPLICATION: function (state, mutation) {
      state.APPLICATION = mutation;
    },
  },
  actions: {},
  modules: {},
  getters: {
    // get Application data
    getAPPLICATION: (state) => {
      return state.APPLICATION;
    },
  },
};
